// src/features/landing/presentation/pages/LandingPage.jsx
import React, { useEffect } from "react";
import { useLandingContent } from "../../application/useLandingContent";
import { HeroSection } from "../components/HeroSection";
import { MainCategoriesSection } from "../components/MainCategoriesSection";
import { Footer } from "../components/Footer";
import { PremiumPopup } from "../components/PremiumPopup";
import { siteVisitRepository } from "../../infrastructure/siteVisitApiRepository";

import "../styles/landing.css";

export function LandingPage() {
    const { heroSlides } = useLandingContent();

    useEffect(() => {
        siteVisitRepository.recordVisit('SITE');
    }, []);

    return (
        <>
            <PremiumPopup />

            {/* 항상 표시되는 흰색 고정 네브바 */}

            {/* 히어로 섹션 (네브바 없음) */}
            <HeroSection slides={heroSlides} showHeroNav={false} />

            {/* 메인 카테고리 섹션 */}
            <MainCategoriesSection />

            <Footer />
        </>
    );
}
